'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const SpendChartInner = dynamic(() => import('./SpendChartInner'), { ssr: false });

export default function SpendChart() {
  return <SpendChartInner />;
}